import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { media, palette } from 'util/style-helpers';

export const CAROUSEL_MOBILE_HEIGHT = 230;
export const CAROUSEL_DESKTOP_HEIGHT = 250;
export const CAROUSEL_TABLET_HEIGHT = 192;

export const CAROUSEL_SIZE = {
  mobile: {
    width: 280,
    height: 230,
  },
  tablet: {
    width: 720,
    height: 192,
  },
  desktop: {
    width: 940,
    height: 250,
  },
};

export const carouselStyle = () => {
  return StyleSheet.create({
    container: {
      position: 'relative',
      background: '#333',
      margin: 'auto',
      width: CAROUSEL_SIZE.mobile.width,
      height: CAROUSEL_SIZE.mobile.height,

      [media.tablet]: {
        width: CAROUSEL_SIZE.tablet.width,
        height: CAROUSEL_SIZE.tablet.height,
      },

      [media.desktop]: {
        width: CAROUSEL_SIZE.desktop.width,
        height: CAROUSEL_SIZE.desktop.height,
      },
    },
  });
};

export const slideStyle: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    background: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      height: CAROUSEL_SIZE.mobile.height,
      margin: '0 auto',

      [media.tablet]: {
        height: CAROUSEL_SIZE.tablet.height,
      },

      [media.desktop]: {
        backgroundSize: 'cover',
        height: CAROUSEL_SIZE.desktop.height,
      },
    },
    content: {
      display: 'flex',
      height: '100%',
      width: '100%',
      flexDirection: 'column',
      margin: '0 auto',
      color: 'white',
      fontSize: 16,
      padding: 20,

      [media.tablet]: {
        width: '75%',
      },

      [media.desktop]: {
        width: '60%',
        padding: '60px 20px',
      },
    },
    title: {
      marginBottom: 20,
      fontSize: 24,
    },
    paragraph: {
      minHeight: 0,
      height: 'fit-content',
      width: '100%',
      overflow: 'hidden',
      textAlign: 'justify',
      marginBottom: 15,
      whiteSpace: 'nowrap',

      [media.tablet]: {
        marginBottom: 20,
      },
    },
    image: {
      backgroundImage: `url(${styles.imageUrlMobile})`,
      backgroundSize: 'cover',
      backgroundPosition: styles.imagePosition ? styles.imagePosition : 'bottom left',
      backgroundRepeat: 'no-repeat',

      [media.tablet]: {
        backgroundImage: `url(${styles.imageUrlDesktop})`,
      },
    },
  });
};

export const dotStyle: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    pagination: {
      width: '100%',
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paginationItem: {
      margin: '5px 10px',
      backgroundColor: palette.lightGrey,
      height: 12,
      width: 12,
      padding: 0,
      borderRadius: '100%',
      cursor: 'pointer',
      border: 'none',

      [media.desktop]: {
        margin: '10px 10px',
      },
    },

    itemSelected: {
      backgroundColor: palette.red,
    },
  });
};
